/**
 * Whether a message asks about videos, so a conversation with no video study
 * attached yet sends this turn to the Reels agent, which finds the study.
 * Deliberately narrow: anything else still goes to DANI unchanged.
 */

const VIDEO_WORDS = /\b(videos?|reels?|clips?)\b/i;

export function isVideoIntent(message: string): boolean {
    return VIDEO_WORDS.test(message);
}
